"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.replace");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _contract = require("@/api/cms/contract");

var _order = require("@/api/cms/order");

var _designSchemeApi = require("@/api/designSchemeApi");

var _cmsWorkOrder = require("@/api/cmsWorkOrder");

var _orderSection = _interopRequireDefault(require("./orderSection"));

var _auth = require("@/utils/auth");

var _vuex = require("vuex");

var _ossUpload = require("@/api/cms/ossUpload");

var _ossUpload2 = _interopRequireDefault(require("@/views/cms/common/ossUpload"));

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'ModifySupplementCreate',
  components: {
    OrderSection: _orderSection.default,
    OssUpload: _ossUpload2.default
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['baseApi', 'filesUploadApi'])), {}, {
    // 过滤掉没有任何物料和附件的分组
    groupsWithMaterials: function groupsWithMaterials() {
      return this.auditGroups.filter(function (g) {
        return g.materials.length > 0 || g.otherMaterials && g.otherMaterials.length > 0 || g.otherFiles && g.otherFiles.length > 0;
      });
    },
    // 有门店权限即可选择经销商和门店（不再区分新旧订单）
    canSelectDealerShop: function canSelectDealerShop() {
      return this.checkPer(['modifySupplement:dealer']);
    },
    // 旧单/历史订单数据源（无权限时门店仍沿用旧逻辑）
    isOldOrderData: function isOldOrderData() {
      return this.contractDataSource === 'old' || this.isHistoryOrder;
    }
  }),
  data: function data() {
    return {
      headers: {
        'Authorization': (0, _auth.getToken)()
      },
      submitting: false,
      submitted: false,
      // 当前选中的合同
      selectedContract: null,
      // 门店列表（旧数据选择门店用，按经销商过滤）
      dealerShopList: [],
      selectedDealerShopCode: '',
      // 经销商列表（旧数据选择经销商用）
      dealerList: [],
      selectedDealerCode: '',
      // 历史订单弹窗
      showHistoryOrderDialog: false,
      historyOrderRules: {
        contractNo: [{
          required: true,
          message: '请输入合同号',
          trigger: 'blur'
        }, {
          validator: this.validateContractNo,
          trigger: 'blur'
        }],
        productionOrder: [{
          required: true,
          message: '请输入销售单号',
          trigger: 'blur'
        }],
        custName: [{
          required: true,
          message: '请输入客户姓名',
          trigger: 'blur'
        }],
        custMobile: [{
          required: true,
          message: '请输入客户电话',
          trigger: 'blur'
        }],
        custAddress: [{
          required: true,
          message: '请输入客户地址',
          trigger: 'blur'
        }]
      },
      historyOrderForm: {
        contractNo: '',
        productionOrder: '',
        custName: '',
        custMobile: '',
        custAddress: '',
        region: '',
        orderClerkNickName: '',
        designerNickName: '',
        guideNickName: '',
        channelType: '',
        installMamager: '',
        installGroup: '',
        installPerson: '',
        installFinishTime: '',
        createdatetime: ''
      },
      form: {
        contractId: '',
        contractNoDisplay: '',
        modifyType: '',
        problemCause: '',
        problemNow: '',
        problemDescription: '',
        problemImg: '',
        contactPerson: '',
        contactAddress: '',
        contactNumber: '',
        requiredDeliveryDate: ''
      },
      problemNowOptions: [{
        label: '现场单',
        value: '现场单'
      }, {
        label: '售后单',
        value: '售后单'
      }, {
        label: '厂内改',
        value: '厂内改'
      }, {
        label: '正单遗留单',
        value: '正单遗留单'
      }],
      // 上传文件列表
      problemImgUploadList: [],
      otherFileUploadList: [],
      // 上传物料附件弹窗（先选择原单号）
      showOtherFileDialog: false,
      // 弹窗中当前选中的原单号
      otherFileSelectedAudit: null,
      uploadProblemImgs: [],
      uploadOtherFiles: [],
      uploadFile: [],
      rules: {
        contractId: [{
          required: true,
          message: '请选择合同',
          trigger: 'change'
        }],
        problemCause: [{
          validator: this.requiredUnlessNewMaterial('请输入问题原因'),
          trigger: 'blur'
        }],
        problemNow: [{
          validator: this.requiredUnlessNewMaterial('请输入问题现状'),
          trigger: 'blur'
        }],
        modifyType: [{
          required: true,
          message: '请选择改补类型',
          trigger: 'change'
        }],
        requiredDeliveryDate: [{
          required: true,
          validator: this.requiredField('请选择期望到货日期'),
          trigger: 'change'
        }]
      },
      // 合同选择弹窗
      showContractDialog: false,
      contractTableLoading: false,
      contractTableList: [],
      contractPage: 1,
      contractPageSize: 10,
      contractTotal: 0,
      tempSelectedContract: null,
      contractDataSource: 'new',
      isHistoryOrder: false,
      contractSearchForm: {
        contractNo: '',
        originalContractNo: '',
        productionOrder: '',
        name: '',
        mobile: '',
        address: ''
      },
      // 酷家乐下单，提交后才显示
      showOrderSection: false,
      orderSectionVisible: true,
      newContractId: '',
      newContractNo: '',
      // ============ 选择原单物料弹窗 ============
      showOriginalMaterialDialog: false,
      originalMaterialLoading: false,
      originalMaterialList: [],
      originalMaterialPage: 1,
      originalMaterialPageSize: 10,
      originalMaterialTotal: 0,
      tempSelectedOriginalMaterials: [],
      originalMaterialSearch: {
        name: '',
        code: '',
        barcode: ''
      },
      // ============ 选择其它物料弹窗 ============
      showOtherMaterialDialog: false,
      otherMaterialLoading: false,
      otherMaterialList: [],
      otherMaterialPage: 1,
      otherMaterialPageSize: 10,
      otherMaterialTotal: 0,
      tempSelectedOtherMaterials: [],
      otherMaterialSearch: {
        name: '',
        code: '',
        categoryName: ''
      },
      // 旧库BOM查询
      oldBomSalesOrderId: '',
      oldBomSalesOrderIdFull: '',
      oldBomPage: 1,
      // 原单设计方案的审核单列表（选择合同后加载）
      originalAuditList: [],
      // 弹窗中当前选中的审核单
      dialogSelectedAudit: null,
      // 当前审核单对应的BOM数据
      originalMaterialBomList: [],
      originalMaterialBomListFull: [],
      // 是否正在显示BOM列表（false=显示审核单列表，true=显示BOM列表）
      showOriginalBomView: false,
      originalBomLoading: false,
      // 原单物料分组（按原单号）- 每组包含原单物料和其它物料
      auditGroups: [],
      // 标记从"选择其它物料"进入选择原单号流程
      selectingOtherWithOrder: false,
      searchTimer: null
    };
  },
  activated: function activated() {
    var _this = this;

    // 只有从列表页点击"发起改补"进入时才清空（带 fresh=1 参数）
    if (this.$route.query.fresh) {
      this.resetForm(); // 清除 fresh 参数，防止重复触发

      this.$router.replace({
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          fresh: undefined
        })
      }); // 如果从列表页传入了合同ID，自动选中

      var contractId = this.$route.query.contractId;

      if (contractId) {
        this.form.contractId = Number(contractId);
        this.form.contractNoDisplay = this.$route.query.contractNo || ''; // 加载合同详情

        (0, _contract.queryOriginal)({
          page: 0,
          size: 1,
          id: Number(contractId)
        }).then(function (response) {
          if (response.code === 200) {
            var list = response.data || [];

            if (list.length > 0) {
              _this.selectedContract = list[0];
              _this.form.contactPerson = list[0].custName || '';
              _this.form.contactNumber = list[0].custMobile || '';
              _this.form.contactAddress = list[0].custAddress || '';
            }
          }
        }).catch(function () {});
      }
    }
  },
  watch: {
    // 经销商切换时重新加载门店列表
    selectedDealerCode: function selectedDealerCode(val) {
      if (this.canSelectDealerShop || this.isOldOrderData) {
        this.loadDealerShopByDealer(val);
      }
    },
    // 改补类型切换时，非"新增物料"清空物料附件
    'form.modifyType': function formModifyType(val) {
      if (val !== '新增物料') {
        this.otherFileUploadList = [];
        this.uploadOtherFiles = [];
        this.showOtherFileDialog = false;
        this.otherFileSelectedAudit = null; // 同步清理各分组中的附件，空分组移除

        this.auditGroups.forEach(function (group) {
          if (group.otherFiles) {
            group.otherFiles = [];
          }
        });
        this.auditGroups = this.auditGroups.filter(function (g) {
          return g.materials.length > 0 || g.otherMaterials && g.otherMaterials.length > 0;
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
  },
  methods: {
    // 通过后端签发的策略直传 OSS，避免线上反向代理转发 multipart 文件失败
    uploadFileToOss: function uploadFileToOss(type, options) {
      var _this2 = this;

      var file = options.file;
      (0, _ossUpload.getOssPolicy)().then(function (policyData) {
        var directory = type === 'problemVideo' ? 'video' : type === 'otherFile' ? 'file' : 'image';

        var key = 'upload/' + directory + '/' + _this2.generateObjectKey(file.name);

        var formData = new FormData();
        formData.append('key', key);
        formData.append('OSSAccessKeyId', policyData.accessKeyId);
        formData.append('policy', policyData.policy);
        formData.append('signature', policyData.signature);

        if (policyData.securityToken) {
          formData.append('x-oss-security-token', policyData.securityToken);
        }

        formData.append('success_action_status', '200');
        formData.append('file', file);
        var xhr = new XMLHttpRequest();
        xhr.open('POST', policyData.host, true);
        xhr.addEventListener('load', function () {
          if (xhr.status === 200 || xhr.status === 204) {
            var response = {
              realName: key,
              url: policyData.host + '/' + key,
              name: file.name,
              size: file.size,
              type: type === 'problemVideo' ? '视频' : type === 'otherFile' ? '附件' : '图片'
            };
            options.onSuccess(response);
          } else {
            options.onError(new Error('OSS upload failed: ' + xhr.status));
          }
        });
        xhr.addEventListener('error', function () {
          options.onError(new Error('OSS upload network error'));
        });
        xhr.send(formData);
      }).catch(function (error) {
        options.onError(error);
      });
    },
    generateObjectKey: function generateObjectKey(fileName) {
      var dotIndex = fileName.lastIndexOf('.');
      var extension = dotIndex >= 0 ? fileName.substring(dotIndex) : '';
      return Date.now() + '_' + Math.random().toString(36).substr(2, 8) + extension;
    },
    // 上传文件回调
    handleBeforeUpload: function handleBeforeUpload(file) {
      var isLt100M = file.size / 1024 / 1024 < 100;

      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过 100MB!');
        return false;
      }

      return true;
    },
    // 打开上传物料附件弹窗
    openOtherFileDialog: function openOtherFileDialog() {
      if (!this.form.contractId) {
        this.$message.warning('请先选择原合同');
        return;
      }

      this.otherFileSelectedAudit = null;
      this.showOtherFileDialog = true;
    },
    // 弹窗打开时加载原单号列表（审核单列表）
    loadOtherFileAuditList: function loadOtherFileAuditList() {
      this.otherFileSelectedAudit = null; // 历史订单不需要选择原单号，默认使用填入的销售单号

      if (this.isHistoryOrder) {
        var productionOrder = this.selectedContract && this.selectedContract.productionOrder || '';
        this.otherFileSelectedAudit = {
          id: productionOrder || 'history',
          rowId: productionOrder || 'history',
          productionOrder: productionOrder
        };
        return;
      }

      this.loadContractBomData();
    },
    // 弹窗中选择原单号（点击行）
    handleOtherFileSelectAudit: function handleOtherFileSelectAudit(audit) {
      this.otherFileSelectedAudit = audit;
    },
    // 统计某个原单号下已上传的附件数量
    otherFileCountByOrder: function otherFileCountByOrder(productionOrder) {
      return this.otherFileUploadList.filter(function (f) {
        return (f.productionOrder || '') === (productionOrder || '');
      }).length;
    },
    // 获取某个原单号下已上传的附件列表
    otherFileListByOrder: function otherFileListByOrder(productionOrder) {
      return this.otherFileUploadList.filter(function (f) {
        return (f.productionOrder || '') === (productionOrder || '');
      });
    },
    // 上传物料附件前校验（已在弹窗中选择原单号）
    handleOtherFileBeforeUpload: function handleOtherFileBeforeUpload(file) {
      // 历史订单默认使用填入的销售单号，无需选择原单号
      if (!this.isHistoryOrder && (!this.otherFileSelectedAudit || !this.otherFileSelectedAudit.productionOrder)) {
        this.$message.warning('请先选择原单号，再上传物料附件');
        return false;
      }

      return this.handleBeforeUpload(file);
    },
    handleUploadSuccess: function handleUploadSuccess(type, response, file, fileList) {
      // 物料附件需记录所属原单号
      if (type === 'otherFile') {
        file.productionOrder = this.otherFileSelectedAudit && this.otherFileSelectedAudit.productionOrder || '';
      }

      var extra = type === 'otherFile' ? {
        productionOrder: this.otherFileSelectedAudit && this.otherFileSelectedAudit.productionOrder || ''
      } : {};
      var pathStr = JSON.stringify(_objectSpread(_objectSpread({}, response), {}, {
        localName: file.name
      }, extra));
      var listKey = type + 'UploadList';
      var dataKey = 'upload' + type.charAt(0).toUpperCase() + type.slice(1) + 's';
      this[listKey] = fileList;
      this[dataKey] = this[dataKey] || [];
      this[dataKey].push(pathStr); // 物料附件组合成一条订单数据（按原单号分组）

      if (type === 'otherFile') {
        this.attachOtherFileToGroup(file, pathStr);
      }

      if (type === 'problemImg') {
        this.form.problemImg = this[dataKey].length > 0 ? 'uploaded' : '';
      }
    },
    handleOssFileUploadSuccess: function handleOssFileUploadSuccess(fileInfo, uploadedFiles) {
      var fileList = Array.isArray(uploadedFiles) ? uploadedFiles : [];
      this.uploadFile = fileList.map(function (item) {
        return JSON.stringify({
          realName: item.realName || item.response && item.response.realName || '',
          url: item.url || item.response && item.response.url || '',
          name: item.name || item.localName || item.response && item.response.localName || item.realName || '',
          localName: item.name || item.localName || item.response && item.response.localName || item.realName || '',
          size: item.size || item.response && item.response.size || 0,
          type: item.type || item.response && item.response.type || '附件'
        });
      });
    },
    handleOssFileDeleteSuccess: function handleOssFileDeleteSuccess(file, uploadedFiles) {
      var fileList = Array.isArray(uploadedFiles) ? uploadedFiles : [];
      this.uploadFile = fileList.map(function (item) {
        return JSON.stringify({
          realName: item.realName || item.response && item.response.realName || '',
          url: item.url || item.response && item.response.url || '',
          name: item.name || item.localName || item.response && item.response.localName || item.realName || '',
          localName: item.name || item.localName || item.response && item.response.localName || item.realName || '',
          size: item.size || item.response && item.response.size || 0,
          type: item.type || item.response && item.response.type || '附件'
        });
      });
    },
    // 上传物料附件后，将其组合到对应原单号的分组（形成一条订单数据）
    attachOtherFileToGroup: function attachOtherFileToGroup(file, pathStr) {
      var productionOrder = (file.productionOrder || '').trim();
      if (!productionOrder) return; // 查找或创建对应原单号的分组

      var group = this.auditGroups.find(function (g) {
        return (g.audit.productionOrder || '') === productionOrder;
      });

      if (!group) {
        var audit = this.otherFileSelectedAudit ? _objectSpread({}, this.otherFileSelectedAudit) : {
          productionOrder: productionOrder
        };
        group = {
          audit: audit,
          materials: [],
          otherMaterials: [],
          otherFiles: []
        };
        this.auditGroups.push(group);
      }

      if (!group.otherFiles) {
        this.$set(group, 'otherFiles', []);
      }

      group.otherFiles.push({
        uid: file.uid,
        name: file.name,
        productionOrder: productionOrder,
        path: pathStr
      });
    },
    // 从分组中移除物料附件（同时清理上传列表）
    removeGroupOtherFile: function removeGroupOtherFile(group, f) {
      // 从分组中移除
      group.otherFiles = group.otherFiles.filter(function (item) {
        return item.uid !== f.uid;
      }); // 同步从上传列表中移除

      var target = this.otherFileUploadList.find(function (uf) {
        return uf.uid === f.uid;
      });

      if (target) {
        this.handleUploadRemove('otherFile', target);
      } // 分组为空时移除分组


      if (group.materials.length === 0 && (!group.otherMaterials || group.otherMaterials.length === 0) && group.otherFiles.length === 0) {
        var idx = this.auditGroups.indexOf(group);
        if (idx !== -1) this.auditGroups.splice(idx, 1);
      }
    },
    handleUploadRemove: function handleUploadRemove(type, file) {
      var _this3 = this;

      var listKey = type + 'UploadList';
      var dataKey = 'upload' + type.charAt(0).toUpperCase() + type.slice(1) + 's';
      this[listKey] = this[listKey].filter(function (f) {
        return f.uid !== file.uid;
      });
      var targetName = file.response ? file.response.realName : '';

      if (targetName) {
        this[dataKey] = this[dataKey].filter(function (item) {
          try {
            var o = JSON.parse(item);
            return o.realName !== targetName;
          } catch (_unused) {
            return true;
          }
        });
      } else {
        // 如果 file.response 不存在，用文件名匹配过滤
        this[dataKey] = this[dataKey].filter(function (item) {
          try {
            var o = JSON.parse(item);
            return o.localName !== file.name;
          } catch (_unused2) {
            return true;
          }
        });
      } // 问题图片移除后更新校验字段


      if (type === 'problemImg') {
        this.form.problemImg = this[dataKey].length > 0 ? 'uploaded' : '';
        this.$nextTick(function () {
          _this3.$refs.createForm.validateField('problemImg');
        });
      } // 物料附件移除后，同步清理原单号分组


      if (type === 'otherFile') {
        this.syncOtherFileGroupAfterRemove(file);
      }
    },
    // 移除物料附件后，从原单号分组中清理对应附件
    syncOtherFileGroupAfterRemove: function syncOtherFileGroupAfterRemove(file) {
      var productionOrder = (file.productionOrder || '').trim();
      if (!productionOrder) return;
      var group = this.auditGroups.find(function (g) {
        return (g.audit.productionOrder || '') === productionOrder;
      });
      if (!group || !group.otherFiles) return;
      group.otherFiles = group.otherFiles.filter(function (item) {
        return item.uid !== file.uid;
      }); // 分组无物料、无其它物料、无附件时移除分组

      if (group.materials.length === 0 && (!group.otherMaterials || group.otherMaterials.length === 0) && group.otherFiles.length === 0) {
        var idx = this.auditGroups.indexOf(group);
        if (idx !== -1) this.auditGroups.splice(idx, 1);
      }
    },
    // 必填校验：async-validator 1.x 的 required 规则会忽略 message 显示英文，故用自定义校验器
    requiredField: function requiredField(message) {
      return function (rule, value, callback) {
        if (value === undefined || value === null || value === '') {
          callback(new Error(message));
        } else {
          callback();
        }
      };
    },
    // 必填校验：改补类型为"新增物料"时不必填
    requiredUnlessNewMaterial: function requiredUnlessNewMaterial(message) {
      var _this4 = this;

      return function (rule, value, callback) {
        if (_this4.form.modifyType === '新增物料') {
          callback();
          return;
        }

        if (value === undefined || value === null || value === '') {
          callback(new Error(message));
        } else {
          callback();
        }
      };
    },
    // 加载门店列表
    loadDealerShopList: function loadDealerShopList() {
      var _this5 = this;

      (0, _cmsWorkOrder.queryDealerShop)().then(function (res) {
        if (res.code === 200) {
          _this5.dealerShopList = res.data || [];
        }
      }).catch(function () {
        _this5.dealerShopList = [];
      });
    },
    // 根据经销商编码加载门店列表
    loadDealerShopByDealer: function loadDealerShopByDealer(dealerCode) {
      var _this6 = this;

      if (!dealerCode) {
        this.dealerShopList = [];
        this.selectedDealerShopCode = '';
        return;
      }

      (0, _cmsWorkOrder.queryDealerShopByDealer)(dealerCode).then(function (res) {
        if (res.code === 200) {
          _this6.dealerShopList = res.data || [];
        } else {
          _this6.dealerShopList = [];
        }

        _this6.selectedDealerShopCode = '';
      }).catch(function () {
        _this6.dealerShopList = [];
        _this6.selectedDealerShopCode = '';
      });
    },
    // 加载经销商列表
    loadDealerList: function loadDealerList() {
      var _this7 = this;

      (0, _cmsWorkOrder.queryDealer)().then(function (res) {
        if (res.code === 200) {
          _this7.dealerList = res.data || [];
        }
      }).catch(function () {
        _this7.dealerList = [];
      });
    },
    // 初始化经销商/门店选择：有权限即可选择（不区分新旧订单）
    // 无权限的旧单/历史订单仍保留原有的门店选择方式
    initDealerShopSelect: function initDealerShopSelect() {
      this.selectedDealerCode = '';
      this.selectedDealerShopCode = '';
      this.dealerShopList = [];

      if (this.canSelectDealerShop) {
        // 先选经销商，再按其加载门店
        this.loadDealerList();
      } else if (this.isOldOrderData) {
        this.loadDealerShopList();
      }
    },
    // 新库改单/补单/新增物料：只传用户实际选择的经销商、门店，未选择则不传该字段
    buildDealerShopParams: function buildDealerShopParams() {
      var _this8 = this;

      var params = {};

      if (this.selectedDealerShopCode) {
        params.dealerShopCode = this.selectedDealerShopCode;
        params.dealerShopName = (this.dealerShopList.find(function (s) {
          return s.shopNo === _this8.selectedDealerShopCode;
        }) || {}).shopName || '';
      }

      if (this.selectedDealerCode) {
        params.dealerCode = this.selectedDealerCode;
        params.dealerName = (this.dealerList.find(function (d) {
          return (d.code || d.name) === _this8.selectedDealerCode;
        }) || {}).name || '';
      }

      return params;
    },
    // 校验合同号是否存在
    validateContractNo: function validateContractNo(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }

      (0, _contract.checkContractNo)(value).then(function (res) {
        if (res.data === true) {
          callback(new Error('合同号已存在，请检查'));
        } else {
          callback();
        }
      }).catch(function () {
        callback(new Error('合同号校验失败，请稍后重试'));
      });
    },
    // 确认历史订单
    confirmHistoryOrder: function confirmHistoryOrder() {
      var _this9 = this;

      this.$refs.historyOrderForm.validate(function (valid) {
        if (!valid) {
          _this9.$message.warning('请填写必填字段');

          return;
        }

        var h = _this9.historyOrderForm;
        _this9.selectedContract = {
          contractNo: h.contractNo,
          productionOrder: h.productionOrder,
          custName: h.custName,
          custMobile: h.custMobile,
          custAddress: h.custAddress,
          province: h.region,
          orderClerkNickName: h.orderClerkNickName,
          designerNickName: h.designerNickName,
          guideNickName: h.guideNickName,
          channelType: h.channelType,
          installMamager: h.installMamager,
          installGroup: h.installGroup,
          installPerson: h.installPerson,
          installFinishTime: h.installFinishTime,
          createdatetime: h.createdatetime
        };
        _this9.form.contractId = h.contractNo;
        _this9.form.contractNoDisplay = h.contractNo || '历史订单';
        _this9.form.contactPerson = h.custName || '';
        _this9.form.contactNumber = h.custMobile || '';
        _this9.form.contactAddress = h.custAddress || ''; // 历史订单不能补单，默认新增物料

        _this9.form.modifyType = '新增物料';
        _this9.isHistoryOrder = true; // 初始化经销商/门店选择（有权限即可选择，不再区分新旧订单）

        _this9.initDealerShopSelect();

        _this9.showHistoryOrderDialog = false;

        _this9.$refs.createForm.clearValidate('contractId');
      });
    },
    // 从选择合同弹窗打开历史订单弹窗
    openHistoryOrderFromContractDialog: function openHistoryOrderFromContractDialog() {
      this.showContractDialog = false;
      this.showHistoryOrderDialog = true;
    },
    // === 合同选择弹窗 ===
    // 打开弹窗时加载表格
    loadContractTable: function loadContractTable() {
      this.tempSelectedContract = null; // 旧库数据不自动加载，点击搜索才加载

      if (this.contractDataSource === 'old') {
        this.contractTableList = [];
        this.contractTotal = 0;
        this.contractTableLoading = false;
      } else {
        this.handleContractSearch();
      }
    },
    // 切换数据源
    handleContractDataSourceChange: function handleContractDataSourceChange() {
      this.contractPage = 1;
      this.contractTableList = [];
      this.contractTotal = 0;
      this.tempSelectedContract = null; // 旧库数据不自动加载，搜索时才加载；新库和改补订单自动加载

      if (this.contractDataSource === 'new' || this.contractDataSource === 'modify') {
        this.contractTableLoading = true;
        this.queryContractTable();
      } else {
        this.contractTableLoading = false;
      } // 旧数据默认补单（用户可切换）


      if (this.contractDataSource === 'old' && !this.form.modifyType) {
        this.form.modifyType = '补单';
      }
    },
    // 搜索
    handleContractSearch: function handleContractSearch() {
      this.contractTableLoading = true;
      this.contractPage = 1;
      this.queryContractTable();
    },
    handleContractSearchReset: function handleContractSearchReset() {
      this.contractSearchForm = {
        contractNo: '',
        originalContractNo: '',
        productionOrder: '',
        name: '',
        mobile: '',
        address: ''
      };
      this.handleContractSearch();
    },
    queryContractTable: function queryContractTable() {
      var _this10 = this;

      var params = {
        page: this.contractPage - 1,
        size: 10
      };

      if (this.contractDataSource === 'old') {
        if (this.contractSearchForm.contractNo) params.contractId = this.contractSearchForm.contractNo; // Ishare 订单按 orderId 搜索生产单号

        if (this.contractSearchForm.productionOrder) params.orderId = this.contractSearchForm.productionOrder;
        if (this.contractSearchForm.name) params.contact = this.contractSearchForm.name;
        if (this.contractSearchForm.mobile) params.tel = this.contractSearchForm.mobile;
        if (this.contractSearchForm.address) params.address = this.contractSearchForm.address;
        params.sort = 'createdatetime,desc';
      } else if (this.contractDataSource === 'modify') {
        // 改补订单：与改补列表页一致的查询参数
        if (this.contractSearchForm.contractNo) params.contractNo = this.contractSearchForm.contractNo;
        if (this.contractSearchForm.originalContractNo) params.originalContractNo = this.contractSearchForm.originalContractNo;
        if (this.contractSearchForm.name) params.name = this.contractSearchForm.name;
        if (this.contractSearchForm.mobile) params.mobile = this.contractSearchForm.mobile;
        if (this.contractSearchForm.address) params.address = this.contractSearchForm.address;
        params.sort = 'createTime,desc';
      } else {
        if (this.contractSearchForm.contractNo) params.contractNo = this.contractSearchForm.contractNo; // 新 CRM 订单按 productionOrder 搜索生产单号

        if (this.contractSearchForm.productionOrder) params.productionOrder = this.contractSearchForm.productionOrder;
        if (this.contractSearchForm.name) params.name = this.contractSearchForm.name;
        if (this.contractSearchForm.mobile) params.mobile = this.contractSearchForm.mobile;
        if (this.contractSearchForm.address) params.address = this.contractSearchForm.address;
        params.sort = 'createdatetime,desc';
      }

      var apiFn;

      if (this.contractDataSource === 'old') {
        apiFn = _contract.getHistoryContractList;
      } else if (this.contractDataSource === 'modify') {
        apiFn = _contract.queryModifySupplementV2;
      } else {
        apiFn = _contract.queryOriginal;
      }

      apiFn(params).then(function (response) {
        var dataList = response.data || response || [];
        var list = Array.isArray(dataList) ? dataList : dataList.content || []; // 旧库字段名映射

        if (_this10.contractDataSource === 'old') {
          list = list.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              id: item.salesOrderId || item.contractId,
              contractNo: item.contractId || '',
              custName: item.contact || '',
              custMobile: item.tel || '',
              custAddress: item.address || '',
              productionOrder: item.salesOrderId || ''
            });
          });
        } // 改补订单：展平嵌套的 contract + audit + contractAfter 结构


        if (_this10.contractDataSource === 'modify') {
          list = list.map(function (item) {
            var contract = item.contract || {};
            var audit = item.audit || {};
            var contractAfter = item.contractAfter || {};

            var flat = _objectSpread(_objectSpread({}, contract), audit);

            return _objectSpread(_objectSpread({}, flat), {}, {
              id: contract.id != null ? contract.id : contract.rowId || audit.rowId || '',
              contractNo: contract.contractNo || '',
              originalContractNo: flat.originalContractNo || contract.originalOrder || contract.originalContractNo || '',
              productionOrder: audit.productionOrder || flat.productionOrder || '',
              custName: contract.custName || '',
              custMobile: contract.custMobile || '',
              custAddress: contract.custAddress || '',
              amendmentType: contractAfter.amendmentType || '',
              createdatetime: contractAfter.createTime || contract.createTime || audit.createTime || '',
              rowId: audit.rowId || contract.id
            });
          });
        }

        _this10.contractTableList = list;
        _this10.contractTotal = dataList.totalElements || dataList.count || list.length || 0;
      }).catch(function () {
        _this10.contractTableList = [];
        _this10.contractTotal = 0;
      }).finally(function () {
        _this10.contractTableLoading = false;
      });
    },
    handleContractPageChange: function handleContractPageChange(page) {
      this.contractPage = page;
      this.contractTableLoading = true;
      this.queryContractTable();
    },
    // 点击行直接选中
    handleContractTableRowClick: function handleContractTableRowClick(row) {
      this.tempSelectedContract = row;
      this.$refs.contractSelectTable.setCurrentRow(row); // 直接确定选择

      this.confirmContractSelect();
    },
    // 确认选择合同
    confirmContractSelect: function confirmContractSelect() {
      this.isHistoryOrder = false;
      if (!this.tempSelectedContract) return;
      this.form.contractId = this.tempSelectedContract.id;
      this.form.contractNoDisplay = this.tempSelectedContract.contractNo || '合同#' + this.tempSelectedContract.id;
      this.selectedContract = this.tempSelectedContract; // 取原合同号（优先用返回的字段，没有则用当前合同号）

      var originalContractNo = this.tempSelectedContract.originalContractNo || this.tempSelectedContract.originalContract || this.tempSelectedContract.originalOrder || this.tempSelectedContract.contractNo;
      this.$set(this.selectedContract, 'originalContractNo', originalContractNo); // 从原合同信息中填充联系人、联系电话、联系地址

      this.form.contactPerson = this.tempSelectedContract.custName || '';
      this.form.contactNumber = this.tempSelectedContract.custMobile || '';
      this.form.contactAddress = this.tempSelectedContract.custAddress || ''; // 旧数据默认补单

      if (this.contractDataSource === 'old' && !this.form.modifyType) {
        this.form.modifyType = '补单';
      } // 初始化经销商/门店选择（有权限即可选择，不再区分新旧订单）


      this.initDealerShopSelect(); // 切换合同，清空原单号、物料分组和其它物料

      this.dialogSelectedAudit = null;
      this.originalAuditList = [];
      this.originalMaterialBomListFull = [];
      this.originalMaterialBomList = [];
      this.showOriginalBomView = false;
      this.tempSelectedOriginalMaterials = [];
      this.tempSelectedOtherMaterials = [];
      this.auditGroups = [];
      this.selectingOtherWithOrder = false;
      this.otherFileSelectedAudit = null;
      this.showOtherFileDialog = false;
      this.otherFileUploadList = [];
      this.uploadOtherFiles = [];
      this.showContractDialog = false;
      this.$refs.createForm.clearValidate('contractId');
    },
    // 提交
    handleSubmit: function handleSubmit() {
      var _this11 = this;

      // 防重复提交：立即锁定，避免连点触发多次
      if (this.submitting || this.submitted) return;
      this.submitting = true;
      this.$refs.createForm.validate(function (valid) {
        var _commonParams, _objectSpread2;

        if (!valid) {
          _this11.submitting = false;

          _this11.$message.warning('请填写必填字段');

          return;
        } // 补单/新增物料时，必须至少选择一个原单物料（已上传物料附件时可跳过）


        if ((_this11.form.modifyType === '补单' || _this11.form.modifyType === '新增物料') && _this11.auditGroups.length === 0 && (!_this11.uploadOtherFiles || _this11.uploadOtherFiles.length === 0)) {
          _this11.submitting = false;

          _this11.$message.warning('请先选择原单物料或上传物料附件');

          return;
        } // 可选择门店时（有权限或旧单/历史订单兜底）门店必填


        if ((_this11.canSelectDealerShop || _this11.isOldOrderData) && !_this11.selectedDealerShopCode) {
          _this11.submitting = false;

          _this11.$message.warning('请选择门店');

          return;
        } // 有权限时经销商必填


        if (_this11.canSelectDealerShop && !_this11.selectedDealerCode) {
          _this11.submitting = false;

          _this11.$message.warning('请选择经销商');

          return;
        }

        _this11.submitting = true; // 旧数据/历史订单使用 addReplenishmentCreate，和新库传参一致，多传 oldContract

        var isOldData = _this11.contractDataSource === 'old' || _this11.isHistoryOrder;
        var commonParams = (_commonParams = {
          contractId: _this11.form.contractId,
          problemImg: _this11.uploadProblemImgs,
          file: _this11.uploadFile,
          otherFile: _this11.uploadOtherFiles,
          problemCause: _this11.form.problemCause,
          problemNow: _this11.form.problemNow,
          problemDescription: _this11.form.problemDescription,
          requiredDeliveryDate: _this11.form.requiredDeliveryDate,
          contactPerson: _this11.form.contactPerson,
          contactAddress: _this11.form.contactAddress,
          contactNumber: _this11.form.contactNumber,
          salesOrderId: _this11.selectedContract ? _this11.selectedContract.salesOrderId || '' : '',
          address: _this11.selectedContract ? _this11.selectedContract.address || _this11.selectedContract.custAddress || '' : '',
          contact: _this11.selectedContract ? _this11.selectedContract.contact || _this11.selectedContract.custName || '' : ''
        }, (0, _defineProperty2.default)(_commonParams, "contractId", _this11.selectedContract ? _this11.selectedContract.contractId || _this11.selectedContract.contractNo || '' : ''), (0, _defineProperty2.default)(_commonParams, "tel", _this11.selectedContract ? _this11.selectedContract.tel || _this11.selectedContract.custMobile || '' : ''), (0, _defineProperty2.default)(_commonParams, "orderDate", _this11.selectedContract ? _this11.selectedContract.orderDate || '' : ''), (0, _defineProperty2.default)(_commonParams, "dealerShopCode", _this11.selectedDealerShopCode || ''), (0, _defineProperty2.default)(_commonParams, "dealerShopName", _this11.selectedDealerShopCode ? (_this11.dealerShopList.find(function (s) {
          return s.shopNo === _this11.selectedDealerShopCode;
        }) || {}).shopName || '' : ''), (0, _defineProperty2.default)(_commonParams, "dealerCode", _this11.selectedDealerCode || ''), (0, _defineProperty2.default)(_commonParams, "dealerName", _this11.selectedDealerCode ? (_this11.dealerList.find(function (d) {
          return (d.code || d.name) === _this11.selectedDealerCode;
        }) || {}).name || '' : ''), _commonParams);
        var apiCall = isOldData && (_this11.form.modifyType === '补单' || _this11.form.modifyType === '新增物料') ? (0, _contract.addReplenishmentCreate)(_objectSpread(_objectSpread({}, commonParams), {}, {
          isMat: _this11.form.modifyType === '新增物料' ? 1 : 0,
          auditList: _this11.auditGroups.map(function (group) {
            return {
              productionOrder: group.audit.productionOrder || '',
              otherFile: (group.otherFiles || []).map(function (f) {
                return f.path;
              }),
              list: (group.materials || []).map(function (m) {
                return {
                  productCode: m.barcode || m.code || '',
                  name: m.name || '',
                  code: m.code || '',
                  materialTypeInfo: m.material || '',
                  color: m.color || '',
                  length: m.length || null,
                  width: m.width || null,
                  height: m.height || null,
                  quantity: m.quantity || null,
                  remark: '',
                  unit: '',
                  typeName: m.typeName || '',
                  barcode: m.barcode || '',
                  spec: m.spec || '',
                  info1: '',
                  info2: '',
                  info3: '',
                  info4: '',
                  info5: m.info5 || '',
                  info6: '',
                  info7: '',
                  info8: '',
                  bomType: 0,
                  doorHingePos: m.doorHingePos || ''
                };
              }).concat((group.otherMaterials || []).map(function (m) {
                return {
                  productCode: m.code || '',
                  name: m.name || '',
                  code: m.code || '',
                  materialTypeInfo: m.material || '',
                  color: m.color || '',
                  length: m.length || null,
                  width: m.width || null,
                  height: m.height || null,
                  quantity: m.quantity || null,
                  remark: '',
                  unit: m.unitName || '',
                  typeName: m.typeName || '',
                  barcode: m.barcode || '',
                  spec: m.spec || m.size || '',
                  info1: '',
                  info2: '',
                  info3: '',
                  info4: '',
                  info5: m.info5 || '',
                  info6: '',
                  info7: '',
                  info8: '',
                  bomType: 1,
                  doorHingePos: m.doorHingePos || ''
                };
              }))
            };
          }),
          list: _this11.getFlatMaterials().map(function (m) {
            return {
              productCode: m.barcode || m.code || '',
              name: m.name || '',
              code: m.code || '',
              materialTypeInfo: m.material || '',
              color: m.color || '',
              length: m.length || null,
              width: m.width || null,
              height: m.height || null,
              quantity: m.quantity || null,
              remark: '',
              unit: m.unitName || '',
              typeName: m.typeName || '',
              barcode: m.barcode || '',
              spec: m.spec || m.size || '',
              info1: '',
              info2: '',
              info3: '',
              info4: '',
              info5: m.info5 || '',
              info6: '',
              info7: '',
              info8: '',
              bomType: m.bomType !== undefined ? m.bomType : 0,
              doorHingePos: m.doorHingePos || ''
            };
          }),
          file: _this11.uploadFile,
          image: '',
          video: '',
          serverUserName: '',
          serverNickName: '',
          questionType: ''
        })) : isOldData ? (0, _contract.addOldContractAndAfter)(_objectSpread({}, commonParams)) : _this11.form.modifyType === '补单' || _this11.form.modifyType === '新增物料' ? (0, _contract.addAfter)(_objectSpread(_objectSpread({
          contractId: _this11.form.contractId
        }, _this11.buildDealerShopParams()), {}, (_objectSpread2 = {
          isMat: _this11.form.modifyType === '新增物料' ? 1 : 0,
          problemImg: _this11.uploadProblemImgs,
          file: _this11.uploadFile,
          otherFile: _this11.uploadOtherFiles,
          problemCause: _this11.form.problemCause,
          problemNow: _this11.form.problemNow,
          problemDescription: _this11.form.problemDescription,
          requiredDeliveryDate: _this11.form.requiredDeliveryDate,
          contactPerson: _this11.form.contactPerson,
          contactAddress: _this11.form.contactAddress,
          contactNumber: _this11.form.contactNumber,
          auditList: _this11.auditGroups.map(function (group) {
            return {
              auditId: group.audit.id || group.audit.rowId || null,
              productionOrder: group.audit.productionOrder || '',
              otherFile: (group.otherFiles || []).map(function (f) {
                return f.path;
              }),
              list: (group.materials || []).map(function (m) {
                return {
                  productCode: m.barcode || m.code || '',
                  name: m.name || '',
                  code: m.code || '',
                  materialTypeInfo: m.material || '',
                  color: m.color || '',
                  length: m.length || null,
                  width: m.width || null,
                  height: m.height || null,
                  quantity: m.quantity || null,
                  remark: '',
                  unit: '',
                  typeName: m.typeName || '',
                  barcode: m.barcode || '',
                  spec: m.spec || '',
                  info1: '',
                  info2: '',
                  info3: '',
                  info4: '',
                  info5: m.info5 || '',
                  info6: '',
                  info7: '',
                  info8: '',
                  bomType: 0,
                  doorHingePos: m.doorHingePos || ''
                };
              }).concat((group.otherMaterials || []).map(function (m) {
                return {
                  productCode: m.code || '',
                  name: m.name || '',
                  code: m.code || '',
                  materialTypeInfo: m.material || '',
                  color: m.color || '',
                  length: m.length || null,
                  width: m.width || null,
                  height: m.height || null,
                  quantity: m.quantity || null,
                  remark: '',
                  unit: m.unitName || '',
                  typeName: m.typeName || '',
                  barcode: m.barcode || '',
                  spec: m.spec || m.size || '',
                  info1: '',
                  info2: '',
                  info3: '',
                  info4: '',
                  info5: m.info5 || '',
                  info6: '',
                  info7: '',
                  info8: '',
                  bomType: 1,
                  doorHingePos: m.doorHingePos || ''
                };
              }))
            };
          }),
          list: _this11.getFlatMaterials().map(function (m) {
            return {
              productCode: m.barcode || m.code || '',
              name: m.name || '',
              code: m.code || '',
              materialTypeInfo: m.material || '',
              color: m.color || '',
              length: m.length || null,
              width: m.width || null,
              height: m.height || null,
              quantity: m.quantity || null,
              remark: '',
              unit: m.unitName || '',
              typeName: m.typeName || '',
              barcode: m.barcode || '',
              spec: m.spec || m.size || '',
              info1: '',
              info2: '',
              info3: '',
              info4: '',
              info5: m.info5 || '',
              info6: '',
              info7: '',
              info8: '',
              bomType: m.bomType !== undefined ? m.bomType : 0,
              doorHingePos: m.doorHingePos || ''
            };
          })
        }, (0, _defineProperty2.default)(_objectSpread2, "file", _this11.uploadFile), (0, _defineProperty2.default)(_objectSpread2, "image", ''), (0, _defineProperty2.default)(_objectSpread2, "video", ''), (0, _defineProperty2.default)(_objectSpread2, "serverUserName", ''), (0, _defineProperty2.default)(_objectSpread2, "serverNickName", ''), (0, _defineProperty2.default)(_objectSpread2, "questionType", ''), _objectSpread2))) : (0, _contract.addChangeContractAndAfter)(_objectSpread(_objectSpread({
          contractId: _this11.form.contractId
        }, _this11.buildDealerShopParams()), {}, {
          problemImg: _this11.uploadProblemImgs,
          file: _this11.uploadFile,
          otherFile: _this11.uploadOtherFiles,
          problemCause: _this11.form.problemCause,
          problemNow: _this11.form.problemNow,
          problemDescription: _this11.form.problemDescription,
          requiredDeliveryDate: _this11.form.requiredDeliveryDate,
          contactPerson: _this11.form.contactPerson,
          contactAddress: _this11.form.contactAddress,
          contactNumber: _this11.form.contactNumber,
          materials: _this11.getFlatMaterials()
        }));
        apiCall.then(function (response) {
          if (response.code === 200) {
            _this11.submitted = true; // 补单/新增物料/改单分别提示

            if (_this11.form.modifyType === '补单') {
              _this11.$message.success('补单提交成功');
            } else if (_this11.form.modifyType === '新增物料') {
              _this11.$message.success('新增物料提交成功');
            } else {
              _this11.$message.success('改单发起成功'); // 改单用返回的合同号显示酷家乐下单


              var resData = response.data;

              if (resData && resData.contractNo) {
                _this11.newContractId = resData.id || resData.rowId || '';
                _this11.newContractNo = resData.contractNo;
                _this11.showOrderSection = true;
              }
            } // OrderSection 组件通过 watch contractId 自动加载酷家乐数据

          } else {
            _this11.$message.error(response.msg || '发起失败');
          }
        }).catch(function (error) {
          console.error('发起改补失败:', error); // 优先显示服务器返回的详细错误信息

          var errMsg = error.response && error.response.data && (error.response.data.msg || error.response.data.message);

          if (errMsg) {
            _this11.$message.error(errMsg);
          } else {
            _this11.$message.error('网络错误，请稍后重试');
          }
        }).finally(function () {
          _this11.submitting = false;
        });
      });
    },
    // 安全读取合同字段（Vue 2 模板不支持可选链）
    getContractField: function getContractField(contract, field) {
      return contract ? contract[field] || '' : '';
    },
    // 合同金额格式化
    getContractAmount: function getContractAmount(contract) {
      if (!contract) return '0.00';
      return (contract.amount || 0).toFixed(2);
    },
    // 切换酷家乐下单折叠
    // 加载合同的设计方案，提取审核单列表（旧库走 getOldOrderList）
    loadContractBomData: function loadContractBomData() {
      var _this12 = this;

      if (!this.form.contractId) return;
      this.originalAuditList = [];
      this.originalBomLoading = true;

      if (this.contractDataSource === 'old') {
        var salesOrderId = this.selectedContract && (this.selectedContract.salesOrderId || this.selectedContract.id);

        if (!salesOrderId) {
          this.originalBomLoading = false;
          this.$message.warning('缺少销售单号');
          return;
        }

        (0, _contract.getOldOrderList)({
          salesOrderId: salesOrderId,
          page: 0,
          size: 10
        }).then(function (response) {
          if (response.code === 200) {
            var list = Array.isArray(response.data) ? response.data : [];
            _this12.originalAuditList = list.map(function (item) {
              return {
                id: item.orderId || item.salesOrderId || '',
                rowId: item.salesOrderId || '',
                productionOrder: item.orderId || '',
                salesOrderId: item.salesOrderId || '',
                auditName: item.auditName || '',
                productionStatus: item.salesOrderStatus || ''
              };
            });
          }
        }).catch(function () {
          _this12.originalAuditList = [];
        }).finally(function () {
          _this12.originalBomLoading = false;
        });
      } else {
        (0, _order.getDesignSchemes)({
          contractId: this.form.contractId
        }).then(function (response) {
          var dataList = Array.isArray(response) ? response : response.data || [];
          var audits = [];
          dataList.forEach(function (scheme) {
            if (scheme.designSchemeAudits && Array.isArray(scheme.designSchemeAudits)) {
              scheme.designSchemeAudits.forEach(function (audit) {
                audits.push(_objectSpread(_objectSpread({}, audit), {}, {
                  id: audit.id || audit.rowId,
                  schemeName: scheme.schemeName || scheme.name || ''
                }));
              });
            }
          });
          _this12.originalAuditList = audits;
        }).catch(function () {
          _this12.originalAuditList = [];
        }).finally(function () {
          _this12.originalBomLoading = false;
        });
      }
    },
    // 切换酷家乐下单折叠
    toggleOrderSection: function toggleOrderSection() {
      this.orderSectionVisible = !this.orderSectionVisible;
    },
    // 选择原单物料
    selectOriginalMaterials: function selectOriginalMaterials() {
      if (!this.selectedContract) {
        this.$message.warning('请先选择原合同');
        return;
      } // 加载审核单/原单号数据，新库和旧库统一流程


      this.loadContractBomData();
      this.dialogSelectedAudit = null;
      this.showOriginalBomView = false;
      this.tempSelectedOriginalMaterial = null;
      this.originalMaterialBomListFull = [];
      this.originalMaterialList = [];
      this.selectingOtherWithOrder = false;
      this.showOriginalMaterialDialog = true;
    },
    // 加载旧库BOM数据
    loadOldBomData: function loadOldBomData() {
      this.originalBomLoading = true;
      this.oldBomPage = 1;
      this.queryOldBomTable();
    },
    // 查询旧库BOM表格
    queryOldBomTable: function queryOldBomTable() {
      var _this13 = this;

      var params = {
        salesOrderId: this.oldBomSalesOrderIdFull || '',
        orderId: this.oldBomSalesOrderId || '',
        solutionName: this.originalMaterialSearch.solutionName || '',
        detailName: this.originalMaterialSearch.name || '',
        page: this.oldBomPage,
        limit: this.originalMaterialPageSize
      };
      (0, _contract.getOldBomList)(params).then(function (response) {
        if (response.code === 200) {
          var data = response.data || {};
          var list = data.content || data.records || data.list || [];
          _this13.originalMaterialList = list.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              id: item.barCode || item.orderId,
              name: item.detailName || item.name || '',
              barcode: item.barCode || item.barcode || '',
              code: item.code || '',
              material: item.material || '',
              color: item.color || '',
              length: item.fleng || item.cleng || item.length || null,
              width: item.fwidth || item.cwidth || item.width || null,
              height: item.thk || item.height || null,
              solutionName: item.solutionName || ''
            });
          });
          _this13.originalMaterialTotal = data.totalElements || data.total || data.count || list.length || 0;
        } else {
          _this13.originalMaterialList = [];
          _this13.originalMaterialTotal = 0;
        }
      }).catch(function () {
        _this13.originalMaterialList = [];
        _this13.originalMaterialTotal = 0;
      }).finally(function () {
        _this13.originalBomLoading = false;
      });
    },
    // 选择一个审核单，加载其BOM数据
    handleSelectAudit: function handleSelectAudit(audit) {
      var _this14 = this;

      this.dialogSelectedAudit = audit;
      this.tempSelectedOriginalMaterials = []; // 清空表格选中状态

      this.$nextTick(function () {
        if (_this14.$refs.originalMaterialTable) {
          _this14.$refs.originalMaterialTable.clearSelection();
        }
      }); // 从"选择其它物料"进入时，直接跳转到其它物料弹窗

      if (this.selectingOtherWithOrder) {
        this.confirmOtherWithOrder();
        return;
      }

      this.originalBomLoading = true;
      this.showOriginalBomView = true;
      this.originalMaterialSearch = {
        name: '',
        code: '',
        barcode: '',
        solutionName: ''
      };
      this.originalMaterialPage = 1; // 旧库数据走旧BOM查询

      if (this.contractDataSource === 'old') {
        this.oldBomSalesOrderId = audit.productionOrder || audit.id;
        this.oldBomSalesOrderIdFull = audit.salesOrderId || '';
        this.loadOldBomData();
        return;
      }

      (0, _order.getBomList)(audit.productionOrder).then(function (response) {
        var bomData = [];

        if (response && response.code === 200) {
          bomData = response.data || [];
        } else if (Array.isArray(response)) {
          bomData = response;
        } else if (response && Array.isArray(response.data)) {
          bomData = response.data;
        }

        var boms = bomData.map(function (bom) {
          return _objectSpread(_objectSpread({}, bom), {}, {
            id: bom.id || bom.barcode || bom.code
          });
        });
        _this14.originalMaterialBomListFull = boms;

        _this14.handleOriginalMaterialSearch();
      }).catch(function () {
        _this14.originalMaterialBomListFull = [];
        _this14.originalMaterialBomList = [];
        _this14.originalMaterialTotal = 0;
      }).finally(function () {
        _this14.originalBomLoading = false;
      });
    },
    // 返回审核单列表
    backToAuditList: function backToAuditList() {
      this.showOriginalBomView = false; // 从其它物料进入时，保持标记不重置

      if (!this.selectingOtherWithOrder) {
        this.dialogSelectedAudit = null;
      }

      this.tempSelectedOriginalMaterials = [];
    },
    // 从其它物料流程确认选择订单，跳转到其它物料弹窗
    confirmOtherWithOrder: function confirmOtherWithOrder() {
      var _this15 = this;

      // 保存引用的原单信息
      var audit = this.dialogSelectedAudit;
      if (!audit) return;
      var auditId = audit.id || audit.rowId; // 查找或创建对应分组

      var group = this.auditGroups.find(function (g) {
        return (g.audit.id || g.audit.rowId) === auditId;
      });

      if (!group) {
        var auditCopy = _objectSpread({}, audit); // 历史订单用合同上的销售单号作为原单号


        if (this.isHistoryOrder && this.selectedContract && this.selectedContract.productionOrder) {
          auditCopy.productionOrder = this.selectedContract.productionOrder;
        }

        group = {
          audit: auditCopy,
          materials: [],
          otherMaterials: [],
          otherFiles: []
        };
        this.auditGroups.push(group);
      }

      if (!group.otherMaterials) {
        this.$set(group, 'otherMaterials', []);
      }

      if (!group.otherFiles) {
        this.$set(group, 'otherFiles', []);
      } // 清空其它物料搜索条件和已选项


      this.otherMaterialSearch = {
        name: '',
        code: '',
        categoryName: ''
      };
      this.tempSelectedOtherMaterials = [];
      this.otherMaterialPage = 1;
      this.selectingOtherWithOrder = false;
      this.showOtherMaterialDialog = true;
      this.$nextTick(function () {
        _this15.showOriginalMaterialDialog = false;
      });
    },
    // 打开弹窗时加载
    loadOriginalMaterialTable: function loadOriginalMaterialTable() {
      this.showOriginalBomView = false;

      if (!this.selectingOtherWithOrder) {
        this.dialogSelectedAudit = null;
      }

      this.tempSelectedOriginalMaterials = []; // 加载原单号列表

      if (this.contractDataSource === 'old' && !this.selectingOtherWithOrder) {
        this.loadContractBomData();
      }
    },
    // 关闭原单物料弹窗时，重置标记和表格选中
    handleOriginalMaterialDialogClose: function handleOriginalMaterialDialogClose() {
      var _this16 = this;

      this.selectingOtherWithOrder = false;
      this.tempSelectedOriginalMaterials = [];
      this.$nextTick(function () {
        if (_this16.$refs.originalMaterialTable) {
          _this16.$refs.originalMaterialTable.clearSelection();
        }
      });
    },
    handleOriginalMaterialSearch: function handleOriginalMaterialSearch() {
      this.originalMaterialPage = 1; // 旧库数据走旧BOM查询

      if (this.contractDataSource === 'old' && this.oldBomSalesOrderId) {
        this.oldBomPage = 1;
        this.queryOldBomTable();
        return;
      }

      this.queryOriginalMaterialTable();
    },
    handleOriginalMaterialSearchReset: function handleOriginalMaterialSearchReset() {
      this.originalMaterialSearch = {
        name: '',
        code: '',
        barcode: '',
        solutionName: ''
      };
      this.handleOriginalMaterialSearch();
    },
    queryOriginalMaterialTable: function queryOriginalMaterialTable() {
      var name = (this.originalMaterialSearch.name || '').trim().toLowerCase();
      var code = (this.originalMaterialSearch.code || '').trim().toLowerCase();
      var barcode = (this.originalMaterialSearch.barcode || '').trim().toLowerCase();
      var filtered = this.originalMaterialBomListFull;

      if (name) {
        filtered = filtered.filter(function (item) {
          return (item.name || '').toLowerCase().includes(name);
        });
      }

      if (code) {
        filtered = filtered.filter(function (item) {
          return (item.code || '').toLowerCase().includes(code);
        });
      }

      if (barcode) {
        filtered = filtered.filter(function (item) {
          return (item.barcode || '').toLowerCase().includes(barcode);
        });
      }

      this.originalMaterialTotal = filtered.length;
      var start = (this.originalMaterialPage - 1) * this.originalMaterialPageSize;
      var end = start + this.originalMaterialPageSize;
      this.originalMaterialList = filtered.slice(start, end);
    },
    handleOriginalMaterialPageChange: function handleOriginalMaterialPageChange(page) {
      this.originalMaterialPage = page; // 旧库数据走旧BOM查询

      if (this.contractDataSource === 'old' && this.oldBomSalesOrderId) {
        this.oldBomPage = page;
        this.queryOldBomTable();
        return;
      }

      this.queryOriginalMaterialTable();
    },
    handleOriginalMaterialSelectionChange: function handleOriginalMaterialSelectionChange(rows) {
      this.tempSelectedOriginalMaterials = rows;
    },
    confirmOriginalMaterialSelect: function confirmOriginalMaterialSelect() {
      if (this.tempSelectedOriginalMaterials.length === 0) return;
      if (!this.dialogSelectedAudit) return; // 查找是否已有该原单号的分组

      var auditId = this.dialogSelectedAudit.id || this.dialogSelectedAudit.rowId;
      var group = this.auditGroups.find(function (g) {
        return (g.audit.id || g.audit.rowId) === auditId;
      });

      if (!group) {
        var audit = _objectSpread({}, this.dialogSelectedAudit); // 历史订单用合同上的销售单号作为原单号


        if (this.isHistoryOrder && this.selectedContract && this.selectedContract.productionOrder) {
          audit.productionOrder = this.selectedContract.productionOrder;
        }

        group = {
          audit: audit,
          materials: [],
          otherMaterials: [],
          otherFiles: []
        };
        this.auditGroups.push(group);
      }

      this.tempSelectedOriginalMaterials.forEach(function (m) {
        group.materials.push(_objectSpread(_objectSpread({}, m), {}, {
          bomType: 0
        }));
      });
      this.$message.success('已添加 ' + this.tempSelectedOriginalMaterials.length + ' 个物料');
      this.showOriginalMaterialDialog = false;
    },
    // 选择其它物料
    selectOtherMaterials: function selectOtherMaterials() {
      var _this17 = this;

      // 补单/新增物料时，需先选择原单号
      if (this.form.modifyType === '补单' || this.form.modifyType === '新增物料') {
        if (!this.selectedContract) {
          this.$message.warning('请先选择原合同');
          return;
        } // 历史订单直接选择其它物料，跳过选择订单环节


        if (this.isHistoryOrder) {
          // 用历史订单手动输入的销售单号创建分组
          var productionOrder = this.selectedContract.productionOrder || '';
          var auditId = productionOrder || 'history';
          var group = this.auditGroups.find(function (g) {
            return (g.audit.id || g.audit.rowId) === auditId;
          });

          if (!group) {
            group = {
              audit: {
                id: auditId,
                rowId: auditId,
                productionOrder: productionOrder
              },
              materials: [],
              otherMaterials: [],
              otherFiles: []
            };
            this.auditGroups.push(group);
          }

          if (!group.otherMaterials) {
            this.$set(group, 'otherMaterials', []);
          }

          if (!group.otherFiles) {
            this.$set(group, 'otherFiles', []);
          }

          this.dialogSelectedAudit = group.audit;
          this.otherMaterialSearch = {
            name: '',
            code: '',
            categoryName: ''
          };
          this.tempSelectedOtherMaterials = [];
          this.otherMaterialPage = 1;
          this.showOtherMaterialDialog = true;
          this.$nextTick(function () {
            if (_this17.$refs.otherMaterialTable) _this17.$refs.otherMaterialTable.clearSelection();
          });
          return;
        } // 旧库也走统一流程，加载原单号列表


        if (this.contractDataSource === 'old') {
          this.selectingOtherWithOrder = true;
          this.loadContractBomData();
          this.showOriginalMaterialDialog = true;
          return;
        }

        this.selectingOtherWithOrder = true;
        this.loadContractBomData();
        this.showOriginalMaterialDialog = true;
        return;
      }

      this.showOtherMaterialDialog = true;
    },
    loadOtherMaterialTable: function loadOtherMaterialTable() {
      var _this18 = this;

      this.handleOtherMaterialSearch();
      this.$nextTick(function () {
        if (_this18.$refs.otherMaterialTable) {
          _this18.$refs.otherMaterialTable.clearSelection();
        }
      });
    },
    // 从其它物料弹窗返回订单列表
    backToOrderFromOtherMaterial: function backToOrderFromOtherMaterial() {
      var _this19 = this;

      this.showOtherMaterialDialog = false;
      this.$nextTick(function () {
        _this19.selectingOtherWithOrder = true;

        _this19.loadContractBomData();

        _this19.dialogSelectedAudit = null;
        _this19.showOriginalBomView = false;
        _this19.showOriginalMaterialDialog = true;
      });
    },
    // 输入即搜索（带防抖）
    debouncedOtherMaterialSearch: function debouncedOtherMaterialSearch() {
      var _this20 = this;

      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () {
        _this20.handleOtherMaterialSearch();
      }, 400);
    },
    handleOtherMaterialSearch: function handleOtherMaterialSearch() {
      this.otherMaterialLoading = true;
      this.otherMaterialPage = 1;
      this.queryOtherMaterialTable();
    },
    handleOtherMaterialSearchReset: function handleOtherMaterialSearchReset() {
      this.otherMaterialSearch = {
        name: '',
        code: '',
        categoryName: ''
      };
      this.handleOtherMaterialSearch();
    },
    queryOtherMaterialTable: function queryOtherMaterialTable() {
      var _this21 = this;

      // 旧库走 getOtherOldBom 接口，自动带入当前订单
      if (this.contractDataSource === 'old') {
        var _params = {
          name: this.otherMaterialSearch.name || '',
          code: this.otherMaterialSearch.code || '',
          page: this.otherMaterialPage,
          limit: this.otherMaterialPageSize,
          salesOrderId: this.selectedContract && this.selectedContract.salesOrderId || ''
        };
        (0, _contract.getOtherOldBom)(_params).then(function (response) {
          if (response.code === 200) {
            var data = response.data || {};
            var list = data.content || data.records || data.list || data.data || [];
            _this21.otherMaterialList = list.map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                id: item.id || item.rowId || item.code,
                name: item.name || item.detailName || ''
              });
            });
            _this21.otherMaterialTotal = data.totalElements || data.total || data.count || list.length || 0;
          } else {
            _this21.otherMaterialList = [];
            _this21.otherMaterialTotal = 0;
          }
        }).catch(function () {
          _this21.otherMaterialList = [];
          _this21.otherMaterialTotal = 0;
        }).finally(function () {
          _this21.otherMaterialLoading = false;
        });
        return;
      }

      var params = {
        name: this.otherMaterialSearch.name || '',
        code: this.otherMaterialSearch.code || '',
        categoryName: this.otherMaterialSearch.categoryName || '',
        page: this.otherMaterialPage,
        limit: this.otherMaterialPageSize
      };
      (0, _designSchemeApi.queryMaterial)(params).then(function (response) {
        if (response.code === 200) {
          var data = response.data || {};
          _this21.otherMaterialList = data.data || [];
          _this21.otherMaterialTotal = data.count || 0;
        } else {
          _this21.otherMaterialList = [];
          _this21.otherMaterialTotal = 0;
        }
      }).catch(function () {
        _this21.otherMaterialList = [];
        _this21.otherMaterialTotal = 0;
      }).finally(function () {
        _this21.otherMaterialLoading = false; // 恢复之前选中的行

        _this21.$nextTick(function () {
          _this21.restoreOtherMaterialSelection();
        });
      });
    },
    // 恢复其它物料表格选中状态
    restoreOtherMaterialSelection: function restoreOtherMaterialSelection() {
      var _this22 = this;

      if (!this.$refs.otherMaterialTable) return;
      var table = this.$refs.otherMaterialTable;
      this._restoringSelection = true;
      this.otherMaterialList.forEach(function (row) {
        var isSelected = _this22.tempSelectedOtherMaterials.some(function (s) {
          return (s.id || s.code) === (row.id || row.code);
        });

        if (isSelected) {
          table.toggleRowSelection(row, true);
        }
      });
      this.$nextTick(function () {
        _this22._restoringSelection = false;
      });
    },
    handleOtherMaterialPageChange: function handleOtherMaterialPageChange(page) {
      this.otherMaterialPage = page;
      this.queryOtherMaterialTable();
    },
    handleOtherMaterialRowClick: function handleOtherMaterialRowClick(row) {
      // 多选模式，行点击切换选中
      this.$refs.otherMaterialTable.toggleRowSelection(row);
    },
    handleOtherMaterialSelectionChange: function handleOtherMaterialSelectionChange(rows) {
      var _this23 = this;

      // 程序恢复选中时不覆盖，避免把已选清空
      if (this._restoringSelection) return; // 增量合并：只更新当前页的选中状态，保留其它页的选中项

      var currentPageKeys = new Set(this.otherMaterialList.map(function (r) {
        return r.id || r.code;
      }));
      var checkedKeys = new Set(rows.map(function (r) {
        return r.id || r.code;
      })); // 移除当前页中取消勾选的项

      this.tempSelectedOtherMaterials = this.tempSelectedOtherMaterials.filter(function (item) {
        var key = item.id || item.code;

        if (currentPageKeys.has(key) && !checkedKeys.has(key)) {
          return false;
        }

        return true;
      }); // 添加当前页中新勾选的项

      rows.forEach(function (row) {
        var key = row.id || row.code;

        if (!_this23.tempSelectedOtherMaterials.some(function (s) {
          return (s.id || s.code) === key;
        })) {
          _this23.tempSelectedOtherMaterials.push(row);
        }
      });
    },
    confirmOtherMaterialSelect: function confirmOtherMaterialSelect() {
      if (this.tempSelectedOtherMaterials.length === 0) return;
      if (!this.dialogSelectedAudit) return; // 找到当前原单号对应的分组

      var auditId = this.dialogSelectedAudit.id || this.dialogSelectedAudit.rowId;
      var group = this.auditGroups.find(function (g) {
        return (g.audit.id || g.audit.rowId) === auditId;
      });
      if (!group) return;

      if (!group.otherMaterials) {
        this.$set(group, 'otherMaterials', []);
      }

      this.tempSelectedOtherMaterials.forEach(function (m) {
        group.otherMaterials.push(_objectSpread(_objectSpread({}, m), {}, {
          quantity: m.quantity || 1,
          bomType: 1
        }));
      });
      this.$message.success('已添加 ' + this.tempSelectedOtherMaterials.length + ' 个物料');
      this.showOtherMaterialDialog = false;
    },
    // 删除已选物料（原单）
    removeMaterial: function removeMaterial(groupIndex, materialIndex) {
      var group = this.groupsWithMaterials[groupIndex];

      if (group) {
        group.materials.splice(materialIndex, 1);

        if (group.materials.length === 0 && (!group.otherMaterials || group.otherMaterials.length === 0)) {
          var realIndex = this.auditGroups.indexOf(group);
          if (realIndex !== -1) this.auditGroups.splice(realIndex, 1);
        }
      }
    },
    // 获取展平后的所有物料（用于提交）
    getFlatMaterials: function getFlatMaterials() {
      var result = [];
      this.auditGroups.forEach(function (group) {
        group.materials.forEach(function (m) {
          result.push(_objectSpread({}, m));
        });
        (group.otherMaterials || []).forEach(function (m) {
          result.push(_objectSpread({}, m));
        });
      });
      return result;
    },
    // 删除已选物料（其它）
    removeOtherMaterial: function removeOtherMaterial(groupIndex, materialIndex) {
      var group = this.groupsWithMaterials[groupIndex];

      if (group && group.otherMaterials) {
        group.otherMaterials.splice(materialIndex, 1);

        if (group.materials.length === 0 && group.otherMaterials.length === 0) {
          var realIndex = this.auditGroups.indexOf(group);
          if (realIndex !== -1) this.auditGroups.splice(realIndex, 1);
        }
      }
    },
    // 解析昵称字段 (JSON数组)
    parseNickName: function parseNickName(val) {
      if (!val) return '';

      try {
        var arr = typeof val === 'string' ? JSON.parse(val) : val;
        return Array.isArray(arr) ? arr.join(', ') : val;
      } catch (_unused3) {
        return val;
      }
    },
    goBack: function goBack() {
      this.$router.push('/cms/modifySupplement');
    },
    // 重置表单
    resetForm: function resetForm() {
      this.submitting = false;
      this.submitted = false;
      this.selectedContract = null;
      this.selectedDealerShopCode = '';
      this.dealerShopList = [];
      this.selectedDealerCode = '';
      this.dealerList = [];
      this.showHistoryOrderDialog = false;
      this.historyOrderForm = {
        contractNo: '',
        productionOrder: '',
        custName: '',
        custMobile: '',
        custAddress: '',
        region: '',
        orderClerkNickName: '',
        designerNickName: '',
        guideNickName: '',
        channelType: '',
        installMamager: '',
        installGroup: '',
        installPerson: '',
        installFinishTime: '',
        createdatetime: ''
      };
      this.form = {
        contractId: '',
        contractNoDisplay: '',
        modifyType: '',
        problemCause: '',
        problemNow: '',
        problemDescription: '',
        problemImg: '',
        contactPerson: '',
        contactAddress: '',
        contactNumber: ''
      };
      this.problemImgUploadList = [];
      this.otherFileUploadList = [];
      this.showOtherFileDialog = false;
      this.otherFileSelectedAudit = null;
      this.uploadProblemImgs = [];
      this.uploadOtherFiles = [];
      this.uploadFile = [];

      if (this.$refs.fileUploadRef && this.$refs.fileUploadRef.clearFiles) {
        this.$refs.fileUploadRef.clearFiles();
      }

      this.showOrderSection = false;
      this.orderSectionVisible = true;
      this.newContractId = '';
      this.newContractNo = '';
      this.auditGroups = [];
      this.originalAuditList = [];
      this.dialogSelectedAudit = null;
      this.originalMaterialBomList = [];
      this.originalMaterialBomListFull = [];
      this.showOriginalBomView = false;
      this.selectingOtherWithOrder = false;
      this.isHistoryOrder = false;
      if (this.searchTimer) clearTimeout(this.searchTimer);

      if (this.$refs.createForm) {
        this.$refs.createForm.clearValidate();
      }
    }
  }
};
exports.default = _default;